import { getLocalAuthStorage } from 'utils/localStorage';

const checkIfSessionExpired = config => {
  const { token, expiresIn } = getLocalAuthStorage();

  if (!token || !expiresIn) return config;

  const now = Date.now();
  const expires = new Date(expiresIn).getTime();

  if (now >= expires) {
    window.location.replace('/logout');

    return Promise.reject({
      message: 'Session expired',
      config,
    });
  }

  return config;
};

export { checkIfSessionExpired };
